module.exports = __webpack_public_path__ + "img/B5.eb212d14.png";